module.exports = __webpack_public_path__ + "img/1552666164.171f894b.jpg";